import { render, staticRenderFns } from "./TeamType.vue?vue&type=template&id=290d4966&scoped=true&"
import script from "./TeamType.vue?vue&type=script&lang=js&"
export * from "./TeamType.vue?vue&type=script&lang=js&"
import style0 from "./TeamType.vue?vue&type=style&index=0&id=290d4966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d4966",
  null
  
)

export default component.exports